const INPUT = "INPUT";
const CALCULATION = "CALCULATION";
const INNER_TITLE = "INNER_TITLE";
const ASSUMPTION = "ASSUMPTION";
export const itemType = { INPUT, CALCULATION, INNER_TITLE, ASSUMPTION };

const MONEY = "MONEY";
const NUMBER = "NUMBER";
const PERCENTAGE = "PERCENTAGE";
export const unitType = { MONEY, NUMBER, PERCENTAGE, INNER_TITLE };

const MONEY_SYMBOL = "$";
// currency symbols
const USD = "$";
const EUR = "€"; //euro
const GBP = "£"; //pound
const TRY = "₺"; //Turkish lira
const JPY = "¥"; //Japanese yen
const INR = "₹";

const NUMBER_SYMBOL = "#";
const PERCENTAGE_SYMBOL = "%";
const INNER_TITLE_SYMBOL = "";

export const currencyType = {
  USD: "USD",
  EUR: "EUR",
  GBP: "GBP",
  TRY: "TRY",
  JPY: "JPY",
  INR: "INR",
};

export const unitSymbol = {
  MONEY_SYMBOL,
  NUMBER_SYMBOL,
  PERCENTAGE_SYMBOL,
  INNER_TITLE_SYMBOL,
};

export const getCurrencySymbol = (type) => {
  switch (type) {
    case currencyType.USD:
      return USD;
    case currencyType.EUR:
      return EUR;
    case currencyType.GBP:
      return GBP;
    case currencyType.TRY:
      return TRY;
    case currencyType.JPY:
      return JPY;
    case currencyType.INR:
      return INR;
    default:
      break;
  }
};

export const getUnitSymbolByUnit = (unit) => {
  if (unit === "MONEY") {
    return MONEY_SYMBOL;
  } else if (unit === "NUMBER") {
    return NUMBER_SYMBOL;
  } else if (unit === "PERCENTAGE") {
    return PERCENTAGE_SYMBOL;
  } else if (unit === "INNER_TITLE") {
    return INNER_TITLE_SYMBOL;
  } else {
    console.error("Unknown unit...");
  }
};
